import React from "react";

import { cn } from "../cn";

export function Table({ className, containerClassName, ...props }: React.ComponentProps<"table"> & { containerClassName?: string }) {
  return (
    <div data-slot="table-container" className={cn("tw-relative tw-w-full tw-overflow-x-auto", containerClassName)}>
      <table data-slot="table" className={cn("tw-w-full tw-caption-bottom tw-border-collapse tw-text-sm", className)} {...props} />
    </div>
  );
}

export function TableHeader({ className, ...props }: React.ComponentProps<"thead">) {
  return <thead data-slot="table-header" className={cn("[&_tr]:tw-border-b [&_tr]:tw-border-solid [&_tr]:tw-border-border", className)} {...props} />;
}

export function TableBody({ className, ...props }: React.ComponentProps<"tbody">) {
  return <tbody data-slot="table-body" className={cn("[&_tr:last-child]:tw-border-0", className)} {...props} />;
}

export function TableFooter({ className, ...props }: React.ComponentProps<"tfoot">) {
  return <tfoot data-slot="table-footer" className={cn("tw-border-t tw-border-solid tw-border-border tw-bg-muted/50 tw-font-medium", className)} {...props} />;
}

export function TableRow({ className, ...props }: React.ComponentProps<"tr">) {
  return <tr data-slot="table-row" className={cn("tw-border-b tw-border-solid tw-border-border tw-transition-colors hover:tw-bg-muted/50 data-[state=selected]:tw-bg-muted", className)} {...props} />;
}

export function TableHead({ className, ...props }: React.ComponentProps<"th">) {
  return (
    <th
      data-slot="table-head"
      className={cn("tw-h-10 tw-px-2 tw-text-left tw-align-middle tw-font-normal tw-text-muted-foreground", "[&:has([role=checkbox])]:tw-pr-0 [&>[role=checkbox]]:tw-translate-y-0.5", className)}
      {...props}
    />
  );
}

export function TableCell({ className, ...props }: React.ComponentProps<"td">) {
  return <td data-slot="table-cell" className={cn("tw-p-2 tw-align-middle [&:has([role=checkbox])]:tw-pr-0 [&>[role=checkbox]]:tw-translate-y-0.5", className)} {...props} />;
}

export function TableCaption({ className, ...props }: React.ComponentProps<"caption">) {
  return <caption data-slot="table-caption" className={cn("tw-mt-4 tw-text-sm tw-text-muted-foreground", className)} {...props} />;
}
